import { Box, Flex, Input } from "@chakra-ui/react";
import { useState } from "react";

import ColorPicker from "../components/ColorPicker";

import LayerSubMenu from "./LayerSubMenu";

interface DefaultProps {
  title: string;
  label: string;
}

interface ColorPickerProps extends DefaultProps {
  onChange: (value: string) => void;
  defaultValue: string;

  slider?: undefined;
  colorPickerHeader: JSX.Element;
}

interface SliderOrInputProps extends DefaultProps {
  onChange: (value: number) => void;
  defaultValue: number;

  slider?: true;
  colorPickerHeader?: undefined;
}

const WaterFlowSettingItem: React.FC<ColorPickerProps | SliderOrInputProps> = (props) => {
  const [showColorPickerModal, setColorPickerModal] = useState(false);
  const openColorPickerModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    setColorPickerModal(true);
  };

  return (
    <LayerSubMenu.Item active indent title={props.title}>
      <LayerSubMenu.Item.Name {...{ as: "label", htmlFor: "waterflow-treshold" }}>
        {props.label}
      </LayerSubMenu.Item.Name>
      {/* Slider */}
      {props.slider && !props.colorPickerHeader && (
        <LayerSubMenu.Item.Slider defaultValue={props.defaultValue} onChange={props.onChange} />
      )}
      {/* Color picker */}
      {props.colorPickerHeader && (
        <>
          <LayerSubMenu.Item.Color value={props.defaultValue} onClick={openColorPickerModal} />
          {showColorPickerModal ? (
            <ColorPicker
              initialColor={props.defaultValue}
              onColorSave={props.onChange}
              closeModal={() => setColorPickerModal(false)}
              header={props.colorPickerHeader}
            />
          ) : null}
        </>
      )}
      {/* Default input */}
      {!props.slider && !props.colorPickerHeader && (
        <Flex alignItems="center" gap={1}>
          <Input
            w="40px"
            border="1px solid"
            borderColor="brand.border"
            rounded="standard"
            h="24px"
            px={2}
            name="waterflow-treshold"
            defaultValue={props.defaultValue}
            onChange={(event) => props.onChange(+event.target.value)}
          />
          <Box whiteSpace="nowrap" color="var(--global--color-soft)" fontSize="0.8rem">
            m/s
          </Box>
        </Flex>
      )}
    </LayerSubMenu.Item>
  );
};
export default WaterFlowSettingItem;
